import { useFragment, useQuery } from '@apollo/client/react';
import { AddMetadataDistinctValueSelectionFragmentDoc, MetadataListSelectionDistinctValuesDocument, } from './AddMetadataDistinctValueSelection.gql';
import { ListItemError } from './ListItemError';
import { ListSelection } from './ListSelection';
export function AddMetadataDistinctValueSelection(props) {
    const { from } = props;
    const { data: fragmentData, complete } = useFragment({
        from,
        fragment: AddMetadataDistinctValueSelectionFragmentDoc,
    });
    const { loading, data, error, refetch } = useQuery(MetadataListSelectionDistinctValuesDocument, {
        skip: !complete,
        variables: {
            propertyName: fragmentData.name || '',
        },
    });
    const distinctValues = (data === null || data === void 0 ? void 0 : data.distinctValues) || [];
    const items = distinctValues.reduce((acc, text) => {
        if (typeof text !== 'string') {
            return acc;
        }
        const trimmedValue = text.trim();
        if (trimmedValue === '') {
            return acc;
        }
        return [...acc, { id: trimmedValue, text, value: trimmedValue }];
    }, []);
    if (!complete) {
        return null;
    }
    if (error) {
        return <ListItemError label={fragmentData.label} onRefresh={refetch}/>;
    }
    return (<ListSelection addOnNoMatch label={fragmentData.label} loading={loading} items={items} isMultiSelect={fragmentData.isMultiSelect}/>);
}
